import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage } from 'services/apiError'
import Logo from 'icons/logo-cutilei-simple.png'
import PasswordInput from 'components/Inputs/PasswordInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import { Formik } from 'formik'
import * as Yup from 'yup'

import {
  Container,
  Form,
  Image,
  Title,
  Input,
  ButtonContainer,
  WarningText,
  ErrorContainer
} from './styles'

export default function AdminSignIn () {
  const [errorMessage, setErrorMessage] = useState (null)
  const navigate = useNavigate ()

  const signInValidation = Yup.object ({
    'email': Yup
      .string ()
      .required ('É necessário fornecer um e-mail')
      .email ('Insira um email válido'),
  
    'password': Yup
      .string ()
      .required ('É necessário fornecer uma senha')
      .min (8, 'A senha deve conter no minimo 8 caracteres')
  })

  return (
    <Container>
      <Formik
        validationSchema={signInValidation}
        initialValues={{
          'email': '',
          'password': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            setSubmitting (true)
      
            const { data } = await cutileiApi.post ('/auth/admins', values)
            
            setErrorMessage (null)
            AuthService.signIn (data)
            navigate ('/admin', { replace: true })
          } catch (error) {
            setErrorMessage (getApiErrorMessage (error))
          } finally {
            setSubmitting (false)
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
            <Image src={Logo} alt='Cutilei' width={100}/>
            <Title>Entrar</Title>
            <Input
              type='email'
              placeholder='E-mail'
              onChange={handleChange ('email')}
              value={values.email}
              onBlur={handleBlur ('email')}
            />
            {touched.email && errors.email && (
              <WarningText>
                {errors.email}
              </WarningText>
            )}
            <PasswordInput
              placeholder='Senha'
              value={values.password}
              onChange={handleChange ('password')}
              onBlur={handleBlur ('password')}
              containerStyle={{marginTop: 10}}
            />
            {touched.password && errors.password && (
              <WarningText>
                {errors.password}
              </WarningText>
            )}
            {errorMessage && (
              <ErrorContainer>
                <p>{errorMessage}</p>
              </ErrorContainer>
            )}
            <ButtonContainer>
              <MainButton
                label='Entrar'
                onClick={handleSubmit}
                disabled={isSubmitting}
                loading={isSubmitting}
                width={140}
              />
            </ButtonContainer>
          </Form>
        )}
      </Formik>
    </Container>
  )
}
